export default{

    // header : {
    //     score : '3000'
    // },
    game : {
        lastSuggestionsGroup : [
            
        ],
        lastSuggestionSelf : [

        ],
        group : [
            
        ],
        selfPlayer : {
        },          
        enigmas : [
            
        ],
        currentOpenedEnigma: {},
        equationFinal : '',
        startGame : '',
        now : '2019-05-20T16:08:00-03:00',
        scoreTeam : '',
        chatIds : []
        
    }
}